import React from 'react';
import Modal from './modal';
import { ModalBody, ModalHeader } from './containers';
import styled from 'styled-components';

const ModalWrapper = styled.div`margin: 20px;`
const ContainerWrapper = styled.div`max-width: 80%; margin: 0 auto;`

export const WebCamModal = () => (
    <Modal>
        <ModalWrapper>
            <ModalHeader />
            <ContainerWrapper>
                <ModalBody />
            </ContainerWrapper>
        </ModalWrapper>
    </Modal>
)